<template>
  <div class="detail-table">
    <div class="head">套餐商品信息</div>
    <div class="main">
      <Table :columns="columns" :data="subUserOrderList" border>
        <template slot-scope="{ row }" slot="offerFeeSum">
          <span>{{ row.offerFeeSum | feetoFixedTwo() }}</span>
        </template>
        <template slot-scope="{ row }" slot="chargeFee">
          <span>{{ row.chargeFee | feetoFixedTwo() }}</span>
        </template>

        <template slot-scope="{ row }" slot="paySts">
          <span>{{ row.paySts | initPaySts() }}</span>
        </template>
        <template slot-scope="{ row }" slot="classType">
          <span>{{ row.classType | initClassType() }}</span>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import {
  tableColumnsWidth,

} from '@/assets/js/resetTableStyle'
import { numsFilter } from "@/mixins/mixins";
export default {
  mixins: [numsFilter],
  props: {
    subUserOrderList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      columns: [
        {
          title: '商品子订单号',
          key: 'subInsOrderId'
        }, {
          title: '商品名称',
          key: 'subProductName'
        }, {
          title: '商品类型',
          slot: 'classType',

        }, {
          title: '状态',
          slot: 'paySts',

        }, {
          title: '课时',
          key: 'classroomTotal',

        }, {
          title: '商品价格（元）',
          slot: 'offerFeeSum',

        }, {
          title: '实收金额（元）',
          slot: 'chargeFee',

        },
      ]
    }
  },
  filters: {
    initPaySts(val) {
      let map = {
        0: '待支付',
        1: '已支付',
        2: '已关闭',
        3: '退款处理中',
        4: '退款驳回',
        5: '已退款',
        6: '撤回退款',
        7: '预支付'
      }
      return map[Number(val)] ? map[Number(val)] : ''
    },
    initClassType(val) {
      let map = {
        1: '素质课',
        2: '基础托管',

      }
      return map[Number(val)] ? map[Number(val)] : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-table {
  width: 100%;
  border: rgb(247, 248, 250) 2px solid;
  border-radius: 8px;
  .head {
    background: rgb(247, 248, 250);
    line-height: 40px;
    font-weight: 700;
    padding: 0 20px;
  }
  .main {
    padding: 32px 16px;
  }
}
</style>